/* tslint:disable */
/* eslint-disable */
/**
 * Befunde API
 * Internal API of befunde-ui for searching and downloading Befunde and for managing accounts, users and themes. The lab-transmitter uploads Befunde through it as well.
 *
 * The version of the OpenAPI document: 0.0.0
 * Contact: support@medcom.at
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CumulativeLabResultResponse } from '../model';
// @ts-ignore
import type { LabResultResponse } from '../model';
// @ts-ignore
import type { LabResultsSearchResponse } from '../model';
// @ts-ignore
import type { RestError } from '../model';
/**
 * LabResultApi - axios parameter creator
 * @export
 */
export const LabResultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns the cumulative view of a Befund.
         * @summary Cumulative LabResult
         * @param {string} orderResultId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cumulativeLabResult: async (orderResultId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderResultId' is not null or undefined
            assertParamExists('cumulativeLabResult', 'orderResultId', orderResultId)
            const localVarPath = `/lab-result/{orderResultId}/cumulative`
                .replace(`{${"orderResultId"}}`, encodeURIComponent(String(orderResultId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Downloads one attachment of a Befund by its ID, as attachment or inline.
         * @summary LabResult Attachment
         * @param {string} orderResultId 
         * @param {string} attachmentId 
         * @param {boolean} [inline] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadlabResultAttachment: async (orderResultId: string, attachmentId: string, inline?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderResultId' is not null or undefined
            assertParamExists('downloadlabResultAttachment', 'orderResultId', orderResultId)
            // verify required parameter 'attachmentId' is not null or undefined
            assertParamExists('downloadlabResultAttachment', 'attachmentId', attachmentId)
            const localVarPath = `/lab-result/{orderResultId}/attachment/{attachmentId}`
                .replace(`{${"orderResultId"}}`, encodeURIComponent(String(orderResultId)))
                .replace(`{${"attachmentId"}}`, encodeURIComponent(String(attachmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (inline !== undefined) {
                localVarQueryParameter['inline'] = inline;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Downloads the PDF of a Befund, as attachment or inline.
         * @summary LabResult PDF
         * @param {string} orderResultId 
         * @param {boolean} [inline] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadlabResultPdf: async (orderResultId: string, inline?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderResultId' is not null or undefined
            assertParamExists('downloadlabResultPdf', 'orderResultId', orderResultId)
            const localVarPath = `/lab-result/{orderResultId}/pdf`
                .replace(`{${"orderResultId"}}`, encodeURIComponent(String(orderResultId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (inline !== undefined) {
                localVarQueryParameter['inline'] = inline;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns one Befund with its details; optionally marks it as read.
         * @summary LabResult Detail
         * @param {string} orderResultId 
         * @param {boolean} [markAsRead] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        labResult: async (orderResultId: string, markAsRead?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderResultId' is not null or undefined
            assertParamExists('labResult', 'orderResultId', orderResultId)
            const localVarPath = `/lab-result/{orderResultId}`
                .replace(`{${"orderResultId"}}`, encodeURIComponent(String(orderResultId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (markAsRead !== undefined) {
                localVarQueryParameter['markAsRead'] = markAsRead;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns one page of the Befunde visible to the current user, optionally filtered by a search term.
         * @summary LabResults Search
         * @param {number} page 
         * @param {number} pageSize 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchLabResults: async (page: number, pageSize: number, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('searchLabResults', 'page', page)
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('searchLabResults', 'pageSize', pageSize)
            const localVarPath = `/lab-result`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LabResultApi - functional programming interface
 * @export
 */
export const LabResultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LabResultApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns the cumulative view of a Befund.
         * @summary Cumulative LabResult
         * @param {string} orderResultId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cumulativeLabResult(orderResultId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CumulativeLabResultResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cumulativeLabResult(orderResultId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LabResultApi.cumulativeLabResult']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Downloads one attachment of a Befund by its ID, as attachment or inline.
         * @summary LabResult Attachment
         * @param {string} orderResultId 
         * @param {string} attachmentId 
         * @param {boolean} [inline] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadlabResultAttachment(orderResultId: string, attachmentId: string, inline?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadlabResultAttachment(orderResultId, attachmentId, inline, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LabResultApi.downloadlabResultAttachment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Downloads the PDF of a Befund, as attachment or inline.
         * @summary LabResult PDF
         * @param {string} orderResultId 
         * @param {boolean} [inline] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadlabResultPdf(orderResultId: string, inline?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadlabResultPdf(orderResultId, inline, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LabResultApi.downloadlabResultPdf']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns one Befund with its details; optionally marks it as read.
         * @summary LabResult Detail
         * @param {string} orderResultId 
         * @param {boolean} [markAsRead] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async labResult(orderResultId: string, markAsRead?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LabResultResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.labResult(orderResultId, markAsRead, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LabResultApi.labResult']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns one page of the Befunde visible to the current user, optionally filtered by a search term.
         * @summary LabResults Search
         * @param {number} page 
         * @param {number} pageSize 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchLabResults(page: number, pageSize: number, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LabResultsSearchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchLabResults(page, pageSize, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LabResultApi.searchLabResults']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LabResultApi - factory interface
 * @export
 */
export const LabResultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LabResultApiFp(configuration)
    return {
        /**
         * Returns the cumulative view of a Befund.
         * @summary Cumulative LabResult
         * @param {LabResultApiCumulativeLabResultRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cumulativeLabResult(requestParameters: LabResultApiCumulativeLabResultRequest, options?: RawAxiosRequestConfig): AxiosPromise<CumulativeLabResultResponse> {
            return localVarFp.cumulativeLabResult(requestParameters.orderResultId, options).then((request) => request(axios, basePath));
        },
        /**
         * Downloads one attachment of a Befund by its ID, as attachment or inline.
         * @summary LabResult Attachment
         * @param {LabResultApiDownloadlabResultAttachmentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadlabResultAttachment(requestParameters: LabResultApiDownloadlabResultAttachmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadlabResultAttachment(requestParameters.orderResultId, requestParameters.attachmentId, requestParameters.inline, options).then((request) => request(axios, basePath));
        },
        /**
         * Downloads the PDF of a Befund, as attachment or inline.
         * @summary LabResult PDF
         * @param {LabResultApiDownloadlabResultPdfRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadlabResultPdf(requestParameters: LabResultApiDownloadlabResultPdfRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadlabResultPdf(requestParameters.orderResultId, requestParameters.inline, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns one Befund with its details; optionally marks it as read.
         * @summary LabResult Detail
         * @param {LabResultApiLabResultRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        labResult(requestParameters: LabResultApiLabResultRequest, options?: RawAxiosRequestConfig): AxiosPromise<LabResultResponse> {
            return localVarFp.labResult(requestParameters.orderResultId, requestParameters.markAsRead, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns one page of the Befunde visible to the current user, optionally filtered by a search term.
         * @summary LabResults Search
         * @param {LabResultApiSearchLabResultsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchLabResults(requestParameters: LabResultApiSearchLabResultsRequest, options?: RawAxiosRequestConfig): AxiosPromise<LabResultsSearchResponse> {
            return localVarFp.searchLabResults(requestParameters.page, requestParameters.pageSize, requestParameters.search, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for cumulativeLabResult operation in LabResultApi.
 * @export
 * @interface LabResultApiCumulativeLabResultRequest
 */
export interface LabResultApiCumulativeLabResultRequest {
    /**
     * 
     * @type {string}
     * @memberof LabResultApiCumulativeLabResult
     */
    readonly orderResultId: string
}

/**
 * Request parameters for downloadlabResultAttachment operation in LabResultApi.
 * @export
 * @interface LabResultApiDownloadlabResultAttachmentRequest
 */
export interface LabResultApiDownloadlabResultAttachmentRequest {
    /**
     * 
     * @type {string}
     * @memberof LabResultApiDownloadlabResultAttachment
     */
    readonly orderResultId: string

    /**
     * 
     * @type {string}
     * @memberof LabResultApiDownloadlabResultAttachment
     */
    readonly attachmentId: string

    /**
     * 
     * @type {boolean}
     * @memberof LabResultApiDownloadlabResultAttachment
     */
    readonly inline?: boolean
}

/**
 * Request parameters for downloadlabResultPdf operation in LabResultApi.
 * @export
 * @interface LabResultApiDownloadlabResultPdfRequest
 */
export interface LabResultApiDownloadlabResultPdfRequest {
    /**
     * 
     * @type {string}
     * @memberof LabResultApiDownloadlabResultPdf
     */
    readonly orderResultId: string

    /**
     * 
     * @type {boolean}
     * @memberof LabResultApiDownloadlabResultPdf
     */
    readonly inline?: boolean
}

/**
 * Request parameters for labResult operation in LabResultApi.
 * @export
 * @interface LabResultApiLabResultRequest
 */
export interface LabResultApiLabResultRequest {
    /**
     * 
     * @type {string}
     * @memberof LabResultApiLabResult
     */
    readonly orderResultId: string

    /**
     * 
     * @type {boolean}
     * @memberof LabResultApiLabResult
     */
    readonly markAsRead?: boolean
}

/**
 * Request parameters for searchLabResults operation in LabResultApi.
 * @export
 * @interface LabResultApiSearchLabResultsRequest
 */
export interface LabResultApiSearchLabResultsRequest {
    /**
     * 
     * @type {number}
     * @memberof LabResultApiSearchLabResults
     */
    readonly page: number

    /**
     * 
     * @type {number}
     * @memberof LabResultApiSearchLabResults
     */
    readonly pageSize: number

    /**
     * 
     * @type {string}
     * @memberof LabResultApiSearchLabResults
     */
    readonly search?: string
}

/**
 * LabResultApi - object-oriented interface
 * @export
 * @class LabResultApi
 * @extends {BaseAPI}
 */
export class LabResultApi extends BaseAPI {
    /**
     * Returns the cumulative view of a Befund.
     * @summary Cumulative LabResult
     * @param {LabResultApiCumulativeLabResultRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabResultApi
     */
    public cumulativeLabResult(requestParameters: LabResultApiCumulativeLabResultRequest, options?: RawAxiosRequestConfig) {
        return LabResultApiFp(this.configuration).cumulativeLabResult(requestParameters.orderResultId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Downloads one attachment of a Befund by its ID, as attachment or inline.
     * @summary LabResult Attachment
     * @param {LabResultApiDownloadlabResultAttachmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabResultApi
     */
    public downloadlabResultAttachment(requestParameters: LabResultApiDownloadlabResultAttachmentRequest, options?: RawAxiosRequestConfig) {
        return LabResultApiFp(this.configuration).downloadlabResultAttachment(requestParameters.orderResultId, requestParameters.attachmentId, requestParameters.inline, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Downloads the PDF of a Befund, as attachment or inline.
     * @summary LabResult PDF
     * @param {LabResultApiDownloadlabResultPdfRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabResultApi
     */
    public downloadlabResultPdf(requestParameters: LabResultApiDownloadlabResultPdfRequest, options?: RawAxiosRequestConfig) {
        return LabResultApiFp(this.configuration).downloadlabResultPdf(requestParameters.orderResultId, requestParameters.inline, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns one Befund with its details; optionally marks it as read.
     * @summary LabResult Detail
     * @param {LabResultApiLabResultRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabResultApi
     */
    public labResult(requestParameters: LabResultApiLabResultRequest, options?: RawAxiosRequestConfig) {
        return LabResultApiFp(this.configuration).labResult(requestParameters.orderResultId, requestParameters.markAsRead, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns one page of the Befunde visible to the current user, optionally filtered by a search term.
     * @summary LabResults Search
     * @param {LabResultApiSearchLabResultsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabResultApi
     */
    public searchLabResults(requestParameters: LabResultApiSearchLabResultsRequest, options?: RawAxiosRequestConfig) {
        return LabResultApiFp(this.configuration).searchLabResults(requestParameters.page, requestParameters.pageSize, requestParameters.search, options).then((request) => request(this.axios, this.basePath));
    }
}

